module.exports = __webpack_public_path__ + "static/media/bannerOnDemand.97d99308.png";